import { Box, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  blueColor04,
  border25,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import ErrorToolTipIcon from "../../CatalogBulkUploadNewCopy/Components/ErrorToolTipIcon";
import ImageEditPopup from "../Popup/ImageEditPopup";

function ImageComponent({
  index,
  value,
  onValueChange,
  errorMsg,
  errorPositionRight,
  onDeletePhotos,
}) {
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [image, setImage] = useState(value);

  const [fileInfo, setFileInfo] = useState(null);

  useEffect(() => {
    setImage(value);
  }, [showImagePopup]);

  return (
    <Box position="relative">
      {errorMsg && (
        <Box sx={{ position: "absolute", right: -14, top: -12, zIndex: 11 }}>
          <ErrorToolTipIcon
            errorMsg={errorMsg}
            errorPositionRight={errorPositionRight}
          />
        </Box>
      )}
      {!value ? (
        <IconButton onClick={() => setShowImagePopup(true)}>
          <AddIcon sx={{ color: blueColor04, fontSize: 22 }} />
        </IconButton>
      ) : (
        <Box
          component={"img"}
          src={value}
          sx={{
            width: "35px",
            height: "35px",
            border: border25,
            borderRadius: "7px",
            cursor: "pointer",
          }}
          onClick={() => setShowImagePopup(true)}
        />
      )}
      {showImagePopup && (
        <ImageEditPopup
          index={index}
          openModal={showImagePopup}
          setOpenModal={setShowImagePopup}
          onValueChange={(data, fileDetails) => {
            setImage(data);
            setFileInfo(fileDetails || null);
          }}
          value={image}
          onDeletePhotos={() => {
            setImage("");
            onDeletePhotos();
          }}
          onDoneClick={() => {
            setShowImagePopup(false);
            if(image){
              onValueChange(image, fileInfo);
            }
            // image === "" && value?.length > 0
            //   ? onDeletePhotos()
            //   : onValueChange(image, fileInfo);
          }}
          isDisabled={image?.startsWith("http") && index == 0}
        />
      )}
    </Box>
  );
}

export default ImageComponent;
